











 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ToggleTeamPrivacyMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPublic",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ToggleTeamPrivacySuccess",
  "abstractKey": null
};

(node ).hash = "3cb7e4eafcb6992b9675572b188f025c";

export default node;
